import Vue from 'vue'
import { Route } from 'vue-router'
import {
  AddToCartData,
  RemoveFromCartData,
  createAddToCartEvent,
  createRemoveFromCartEvent,
} from '~/utils/tracking/gtm/cart'
import {
  ProductImpressionData,
  ProductClickData,
  createProductImpressEvent,
  createProductClickEvent,
  ProductDetailData,
  createProductDetailEvent,
} from '~/utils/tracking/gtm/products'
import { createPageViewEvent, Traffic } from '~/utils/tracking/gtm/pageViews'
import {
  EventFireData,
  GtmEventTypes,
  GTM_EVENT_FIRE_EVENT_NAME,
} from '~/utils/tracking/gtm'
import {
  BannerClickData,
  BannerImpressionData,
  SpecialBannerClickData,
  SpecialBannerImpressionData,
  createBannerClickEvent,
  createBannerImpressEvent,
} from '~/utils/tracking/gtm/banners'
import {
  YottlyEventTypes,
  YottlyEventData,
  createCartInteractionEvent,
} from '~/utils/tracking/yottly'

export type AnalyticsEventData =
  | AddToCartData
  | RemoveFromCartData
  | ProductImpressionData
  | ProductClickData
  | YottlyEventData
  | EventFireData
  | BannerClickData
  | BannerImpressionData
  | SpecialBannerClickData
  | SpecialBannerImpressionData

// Banner related events are created in @mg/web-components directive
export type AnalyticsEventType = YottlyEventTypes | GtmEventTypes

Vue.prototype.$pushAnalyticsEvent = function (
  type: AnalyticsEventType,
  data: AnalyticsEventData
) {
  const resolveEvent = {
    [GtmEventTypes.AddToCart]: (data: AddToCartData) =>
      createAddToCartEvent(data),
    [GtmEventTypes.RemoveFromCart]: (data: RemoveFromCartData) =>
      createRemoveFromCartEvent(data),
    [GtmEventTypes.ProductImpression]: (data: ProductImpressionData) =>
      createProductImpressEvent(data),
    [GtmEventTypes.ProductClick]: (data: ProductClickData) =>
      createProductClickEvent(data),
    [GtmEventTypes.ProductDetail]: (data: ProductDetailData) =>
      createProductDetailEvent(data),
    [GtmEventTypes.BannerImpression]: (
      data: BannerImpressionData | SpecialBannerImpressionData
    ) => createBannerImpressEvent(data),
    [GtmEventTypes.BannerClick]: (
      data: BannerClickData | SpecialBannerClickData
    ) => createBannerClickEvent(data),
    [YottlyEventTypes.CartInteraction]: (data: YottlyEventData) =>
      createCartInteractionEvent(data),
    [GtmEventTypes.EventFire]: (data: EventFireData) =>
      new CustomEvent<EventFireData>(GTM_EVENT_FIRE_EVENT_NAME, {
        detail: data,
      }),
  }

  // @ts-ignore
  const event = resolveEvent[type](data)
  window.dispatchEvent(event)
}

Vue.prototype.$trackPageView = function (
  to: Route,
  traffic: Traffic,
  sendChangeQuery = null
) {
  const event = createPageViewEvent(to, traffic, sendChangeQuery)
  window.dispatchEvent(event)
}
